<h4>{{title()}}</h4>
<h5>{{subTitle()}}</h5>

@if (!AppService.isDCApp && videoTips().length > 0) {
<div class="fx-row fx-gap-sm mb-lg">
  <mat-icon>tips_and_updates</mat-icon>
  <div>
    <strong>Uploaded videos must:</strong>
    <p class="m-0">Video files used for YouTube advertising must meet the following criteria:</p>
    <ul class="m-0 pl-4">
      @for (videoTip of videoTips(); track $index) {
      <li>{{videoTip}}</li>
      }
    </ul>
  </div>
</div>
}

<ngx-file-drop accept="video/mp4,video/quicktime,video/x-msvideo,.mp4,.avi,.mov"
  contentClassName="video-drop-zone-content" dropZoneClassName="mb-4 video-drop-zone" [directory]="false"
  [multiple]="false" (onFileDrop)="handleDroppedFile($event)">
  <ng-template let-openFileSelector="openFileSelector" ngx-file-drop-content-tmp>
    @if (!uploadState().isProcessing) {
    <div class="fx-column align-items-center justify-content-center fx-gap-xl">
      <mat-icon class="upload-icon">movie_outline</mat-icon>
      <button color="default" lcTestId="multimediaitem-add-video-link" mat-raised-button type="button"
        (click)="openFileSelector()">
        Upload Video
      </button>
      <p>or drag them in</p>
    </div>
    } @else {
    @if (uploadState().uploadProgress === 100 && uploadState().isSuccessful) {
    <!-- Video successfully uploaded - show preview and remove button -->
    @if (uploadState().videoPreviewUrl) {
    <div class="video-preview-container mb-2">
      @if (!videoLoadError()) {
      <video class="video-preview" controls [src]="uploadState().videoPreviewUrl" (error)="onVideoError($event)"
        (loadeddata)="onVideoLoaded()">
        <track kind="captions" label="English captions" srclang="en" />
        Your browser does not support the video tag.
      </video>
      } @else {
      <div class="video-format-warning">
        <mat-icon>info</mat-icon>
        <p>Video uploaded successfully, but preview is not available.</p>
        <p class="text-muted">Some video formats (like AVI) cannot be previewed in the browser.</p>
        <a rel="noopener" target="_blank" [href]="uploadState().videoPreviewUrl">Download video</a>
      </div>
      }
    </div>
    }
    @if (!videoSubmitted()) {
    <button matButton (click)="removeVideo()">
      <mat-icon class="md">delete_outline</mat-icon>
      Remove Video
    </button>
    }
    } @else if (uploadState().uploadProgress < 100 || !uploadState().isSuccessful) { <!-- Show progress bar and filename
      while uploading or if failed -->
      <p>{{uploadState().selectedVideoFileName}}</p>
      <mat-progress-bar class="mb-2" mode="determinate" [color]="uploadState().loadingBarColor"
        [value]="uploadState().uploadProgress" />

      @if (uploadState().uploadProgress === 100) {
      <!-- Upload failed -->
      @if (uploadState().isSuccessful) {
      <p class="font-weight-bold">Video upload successful</p>
      @if (!videoSubmitted()) {
      <button matButton [disabled]="!canRemoveVideo()" (click)="removeVideo()">
        <mat-icon class="md">delete_outline</mat-icon>
        Remove Video
      </button>
      }
      } @else {
      <div class="fx-row fx-gap-sm align-items-center pb-2">
        <mat-icon color="warn">error_outline</mat-icon>
        <p class="font-weight-bold m-0">Video Upload Failed</p>
        <p class="m-0">- {{uploadState().errorMessage}}</p>
      </div>
      <button class="text-faded" lcTestId="multimediaitem-add-video-link-after-error" matButton type="button"
        (click)="openFileSelector()">
        <mat-icon>upload_outline</mat-icon>
        Upload New Video
      </button>
      }
      }
      }
      }
  </ng-template>
</ngx-file-drop>
<div class="fx-row fx-gap-sm mb-lg">
  <p><i>Note: All video files uploaded will be deleted after six months. This does not impact duration the video will
      be available on YouTube.</i></p>
</div>